import React, { useEffect, useState } from "react";
import { formatElapsed, parseTimer, timerElapsedMs } from "../utils/taskTimer";

const TaskLiveTimer = ({ timer, className = "" }) => {
    const parsed = parseTimer(timer);
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (!parsed.running) return undefined;
        const id = window.setInterval(() => setNow(Date.now()), 1000);
        return () => window.clearInterval(id);
    }, [parsed.running, parsed.startedAt]);

    const ms = timerElapsedMs(parsed, now);
    if (!parsed.running && ms <= 0) return null;

    return (
        <span className={`task-timer ${parsed.running ? "is-live" : ""} ${className}`.trim()}>
            {formatElapsed(ms)}
        </span>
    );
};

export default TaskLiveTimer;
